<template>
	<dms-select-grid v-bind="{labelKey, showLabel, validationOff, span, isSelectable, noLabelAlign, isClearable}" :disabled="selectDisabledCmp"
		@openGrid="openGrid" @clear="clearClick">
		<dms-input ref="input" :value.sync="ndNrCmp" :span="18" :show-label="false" :wrapp="false" :disabled="inputDisabledCmp" class="input-with-select"
			validation-off label-key="ND_NR" :uppercase="uppercase" :autofocus="autofocus" @keyup.enter="onCheckClick($event)"
			@update:value="$emit('update:value', $event)" @clear="clearClick" />
		<dms-button ref="selectButton" :disabled="checkDisabledCmp" label-key="optSklad" style="height:29px" class="spc-button" @click="onCheckClick($event)" />
	</dms-select-grid>
</template>

<script>
import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'ND_NR' },
		showLabel: { type: Boolean, default: true },
		isSelectable: { type: Boolean, default: undefined },
		ndnr: { validator: (prop) => typeof prop === 'string' || prop === null, required: true },
		skladOzn: { type: Number, default: -1 },
		selectDisabled: { type: Boolean, default: undefined },
		inputDisabled: { type: Boolean, default: undefined },
		checkDisabled: { type: Boolean, default: undefined },
		checkSkladFunction: { type: Function, default: undefined },
		uppercase: { type: Boolean, default: false },
		isClearable: { type: Boolean, default: false },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				value: null,
				text: null,
				ndnr: null,
				cenasdph: null,
				vydejmjid: null,
				vyrobekndozn: null,
				quantity: null,
			},
		};
	},
	computed: {
		ndNrCmp: {
			get() {
				return this.ndnr;
			},
			set(val) {
				this.$emit('update:ndnr', val);
			},
		},
		selectDisabledCmp() {
			return this.isDisabled || this.selectDisabled;
		},
		inputDisabledCmp() {
			return this.isDisabled || this.inputDisabled;
		},
		checkDisabledCmp() {
			return this.isDisabled || this.checkDisabled;
		},
	},
	methods: {
		focusInput() {
			this.$refs.input.focus();
		},
		async onCheckClick(event) {
			if (event) {
				event.preventDefault();
			}
			let showGrid = true;
			if (this.checkSkladFunction) {
				showGrid = await this.checkSkladFunction();
			}
			if (showGrid) {
				this.openGrid();
			} else this.$emit('check-click');
		},
		dbToBaseMapper(data) {
			if (data) {
				return {
					value: data.ZAZNAM_ID,
					text: data.TEXT,
					ndnr: data.X_ND_NR,
					cenasdph: data.X_CENA_S_DPH,
					vydejmjid: data.VYDEJ_MJ_ID,
					vyrobekndozn: data.X_VYROBEKND_OZN,
					quantity: data.STAV,
				};
			}
			return this.emptyObject;
		},
	},
});
</script>
